import { render } from "./concept-arch.vue?vue&type=template&id=6476a4d8"
import script from "./concept-arch.vue?vue&type=script&lang=js"
export * from "./concept-arch.vue?vue&type=script&lang=js"

import "./concept-arch.vue?vue&type=style&index=0&id=6476a4d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__